export default {
	styleOverrides: {
		root: {
			boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
		},
		elevation: {
			borderRadius: '12px',
		},
		elevation0: {
			background: 'rgba(255, 255, 255, 0.3)',
			boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
		},
		elevation1: {
			background: 'rgba(255, 255, 255, 0.5)',
			boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
		},
		elevation2: {
			background: 'rgba(255, 255, 255, 0.7)',
			boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
		},
		elevation5: {
			border: ' 1px solid #FFF',
			background: 'rgba(255, 255, 255, 0.30)',
			boxShadow: '5px 4px 10.8px 0px rgba(94, 148, 210, 0.28)',
			backdropFilter: 'blur(3.8px)',
		},
		elevation24: {
			boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
			background:
				'linear-gradient(113.9deg, rgba(204, 245, 254, 0.8) 1.18%, rgba(252, 227, 254, 0.8) 98.58%)',
			border: '3px solid',
			borderImageSource:
				'linear-gradient(135deg, #94E1FA 10.43%, rgba(255, 255, 255, 0) 42.07%, rgba(193, 111, 243, 0) 57.34%, #FFCEF7 90.37%)',
		},
	},
};
// box-shadow: 0px 0px 30px 0px rgba(130, 125, 131, 0.15);
// box-shadow: 7px 4px 30px 0px rgba(130, 125, 131, 0.15);
